module.exports = __webpack_public_path__ + "static/media/farm.71256b7e.svg";